import { Array, Effect, pipe } from "effect";
import { request } from "./request";
import { Schema } from "@effect/schema";
import {
  GraphAddress,
  ProdProtocolKeyService,
  StaticMarket,
} from "@silo/types";
import { UsdFromDecimalString } from "@silo/utils";
import { GraphError } from "./types";

export function getStaticMarkets(): Effect.Effect<
  StaticMarket[],
  GraphError,
  ProdProtocolKeyService
> {
  return Effect.gen(function* () {
    const { silos } = yield* request({
      query,
      schema: StaticMarketsResponse,
    });

    const protocolKey = yield* ProdProtocolKeyService;

    const staticMarkets = pipe(
      silos,
      Array.map((market): StaticMarket => ({ ...market, protocolKey }))
    );

    return staticMarkets;
  });
}

const query = `#graphql
  {
    silos(orderBy: totalValueLockedUSD, orderDirection: desc) {
      id
      archived
      name
      totalValueLockedUSD
    }
}
`;

export type StaticMarketsResponse = typeof StaticMarketsResponse.Type;
export type StaticMarketsResponseEncoded = typeof StaticMarketsResponse.Encoded;

export const StaticMarketsResponse = Schema.Struct({
  silos: Schema.Array(
    Schema.Struct({
      marketAddress: Schema.propertySignature(GraphAddress).pipe(
        Schema.fromKey("id")
      ),
      isDeprecated: Schema.propertySignature(Schema.Boolean).pipe(
        Schema.fromKey("archived")
      ),
      rawSymbol: Schema.propertySignature(Schema.String).pipe(
        Schema.fromKey("name")
      ),
      lastTvlUsd: Schema.propertySignature(UsdFromDecimalString).pipe(
        Schema.fromKey("totalValueLockedUSD")
      ),
    })
  ),
}).annotations({ identifier: "StaticMarketsResponse" });
